import { defineStore } from 'pinia'

import type { FilterStatus } from './types'

import { objectNumberKeys } from '@/utils/object'
import { BuyerEvaluationStatusType } from '@/constants/common'
import { ALL_ASSIGN_ID } from '@/components/organisms/ACompanyAssociationAssigneeFilterField/composables/constants'

// ストアの状態の型を定義
type State = {
  filterCondition: FilterStatus
}

const INITIAL_VALUE = {
  companyName: '',
  industoryType: 0,
  scale: 0,
  questionGroupId: '',
  expiresDate: '',
  status: objectNumberKeys(BuyerEvaluationStatusType),
  assignee: ALL_ASSIGN_ID,
  supplierTemplateId: '',
} satisfies FilterStatus

export const useBuyerScorecardFilterConditionStore = defineStore('buyerScorecardFilterCondition', {
  state: (): State => ({
    filterCondition: { ...INITIAL_VALUE },
  }),
  getters: {
    isInitialState(state): boolean {
      return Object.entries(INITIAL_VALUE).every(([key, value]) => {
        if (key === 'status') {
          const _value = state.filterCondition.status
          if (!Array.isArray(value) || !Array.isArray(_value)) {
            return false
          }
          return JSON.stringify(value.sort()) === JSON.stringify(_value.sort())
        }
        return value === state.filterCondition[key as keyof FilterStatus]
      })
    },
  },
  actions: {
    initExcludeQuestionnaire() {
      this.filterCondition = {
        ...INITIAL_VALUE,
        questionGroupId: this.filterCondition.questionGroupId,
        expiresDate: this.filterCondition.expiresDate,
        supplierTemplateId: this.filterCondition.supplierTemplateId,
      }
    },
  },
})
